module.exports = __webpack_public_path__ + "static/media/dental.4d422a7f.png";